<template>
  <div v-if="showShoppingLists"><slot /></div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ShoppingListVisibilityWrapper",
  computed: {
    ...mapGetters({
      showShoppingLists: "shoppingList/showShoppingLists",
    }),
  },
};
</script>
